import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 20
    },
    paginationContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    filterContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 20,
        flexWrap: "wrap",
        gap: 15
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1
    },
    loaderContainer: {
        alignItems: "center",
        padding: 40
    },
    tableHeader: {
        flexDirection: "row"
    },
    paginationButtons: {
        flexDirection: "row"
    },
    selectBoxLabel: {
        fontWeight: "600",
        fontSize: 14
    },
    filterItem: {
        minWidth: 200,
        flex: 1
    },
    tableCellSmall: {
        flex: 2
    },
    tableCellLarge: {
        flex: 4
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
